// AuthContainer.jsx - A shared container for both Login and Signup forms
import React from 'react';
import { Box, Paper, Container } from '@mui/material';
import styled from 'styled-components';

// Styled container that centers content both horizontally and vertically
const CenteredContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 100px); // Adjust based on your header/footer
  padding: 2rem 0;
`;

// Styled Paper component with consistent width and styling
const FormPaper = styled(Paper)`
  width: 100%;
  max-width: 450px;
  padding: ${props => props.isModal ? '1.5rem' : '2rem'};
  border-radius: 8px;
`;

// Main container component that can be used for both Login and Signup
const AuthContainer = ({ children, isModal = false }) => {
  // For modal view
  if (isModal) {
    return (
      <Box 
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%'
        }}
      >
        <FormPaper elevation={3} isModal={true}>
          {children}
        </FormPaper>
      </Box>
    );
  }

  // For standalone page view
  return (
    <CenteredContainer maxWidth="xs">
      <FormPaper elevation={3}>
        {children}
      </FormPaper>
    </CenteredContainer>
  );
};

export default AuthContainer;
